import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle
} from '@mui/material';
import React from 'react';

interface ConfirmDialogProps {
    open: boolean;
    onClose: (() => void) | null;
    onConfirm: () => void;
    title: string;
    message: string;
    button1Text: string | null;
    button2Text: string;
    confirmColor?: 'primary' | 'error' | 'warning';
    // 3番目ボタン（代替確認）— onConfirmAlt と confirmAltText が両方指定された場合のみ表示
    onConfirmAlt?: () => void;
    confirmAltText?: string;
    confirmAltColor?: 'error' | 'primary' | 'warning';
}

const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
    open,
    onClose,
    onConfirm,
    title,
    message,
    button1Text,
    button2Text,
    confirmColor = 'primary',
    onConfirmAlt,
    confirmAltText,
    confirmAltColor = 'error'
}) => {
    return (
        <Dialog
            open={open}
            onClose={(event, reason) => {
                if (reason !== 'backdropClick' && onClose) {
                    onClose();
                }
            }}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            disableEscapeKeyDown
        >
            <DialogTitle id="alert-dialog-title" sx={{ fontSize: '0.9rem' }}>
                {title}
            </DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description" sx={{ fontSize: '0.8rem' }}>
                    {message.split('\n').map((line, index) => (
                        <React.Fragment key={index}>
                            {line}
                            <br />
                        </React.Fragment>
                    ))}
                </DialogContentText>
            </DialogContent>
            <DialogActions sx={{ px: 3, pb: 2, gap: 1, flexWrap: 'wrap' }}>
                {onClose &&
                    <Button
                        onClick={onClose}
                        variant="outlined"
                        size="small"
                        sx={{ fontSize: '0.8rem' }}
                    >
                        {button1Text}
                    </Button>
                }
                <Box sx={{ flexGrow: 1 }} />
                {/* 一時保存削除など代替確認ボタン — onConfirmAlt と confirmAltText が両方指定された場合のみ表示 */}
                {onConfirmAlt && confirmAltText && (
                    <Button
                        onClick={onConfirmAlt}
                        variant="contained"
                        color={confirmAltColor}
                        size="small"
                        sx={{ fontSize: '0.8rem' }}
                    >
                        {confirmAltText}
                    </Button>
                )}
                <Button
                    onClick={onConfirm}
                    variant="contained"
                    color={confirmColor}
                    size="small"
                    sx={{ fontSize: '0.8rem' }}
                    autoFocus
                >
                    {button2Text}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ConfirmDialog;